{/* Copyright 2026 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0
Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License. */}

import {Layout} from '../../../src/Layout';
export default Layout;
import {FunctionAPI} from '../../../src/FunctionAPI';
import {InterfaceType} from '../../../src/types';
import docs from 'docs:@react-aria/textfield';
import Anatomy from '/packages/dev/s2-docs/pages/react-aria/TextFieldAnatomy.svg';

export const section = 'Hooks';
export const description = 'Provides the behavior and accessibility implementation for a text field.';
export const isSubpage = true;

# useTextField

<PageDescription>{docs.exports.useTextField.description}</PageDescription>

```tsx render files={["starters/hooks/src/TextField.tsx", "starters/hooks/src/TextField.css", "starters/hooks/src/Form.css"]}
"use client";
import {TextField} from 'hooks-starter/TextField';

<TextField label="Email" />
```

## API

<Anatomy />

```tsx
<TextField>
  <Label />
  <Input /> or <TextArea />
  <Text slot="description" />
  <FieldError />
</TextField>
```

<FunctionAPI function={docs.exports.useTextField} links={docs.links} />

### AriaTextFieldProps

<InterfaceType {...docs.exports.AriaTextFieldProps} />

### TextFieldAria

<InterfaceType {...docs.exports.TextFieldAria} />
